webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return us; });
/* unused harmony export options */
/* unused harmony export pageList */
/* unused harmony export detail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);




var adds = function adds(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    method: 'get',
    params: data,
    url: '/api/ttg/columns'

  });
};
var us = function us(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    method: 'get',
    params: data,
    url: '/api/ttg/page'

  });
};
var options = function options(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    method: 'get',
    params: data,
    url: '/api/ttg/options'

  });
};

var pageList = function pageList(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    method: 'get',
    params: data,
    url: '/api/ttg/page/list'

  });
};
var detail = function detail(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    method: 'get',
    params: data,
    url: '/api/ttg/detail'

  });
};

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);




var loading = void 0;
function startLoading() {
  loading = __WEBPACK_IMPORTED_MODULE_3_element_ui__["Loading"].service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}
function endLoading() {
  loading.close();
}
var service = __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].create({
  baseUrl: 'http://cms.saveus.cn',
  timeout: 15000 });
service.interceptors.response.use(function (res) {
  console.log(res);
  startLoading();
  if (res.status === 200) {
    if (res.data.code === 0) {
      endLoading();
      return res.data;
    } else {
      tool.message(res.data.msg, 'error');
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.data);
    }
  } else {
    tool.message(res.data.msg, 'error');
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res.data);
  }
}, function (error) {
  var r = error.response;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_new_home__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_new_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_new_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Solution__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Solution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Solution__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Product__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ContactUs__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_ContactUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_ContactUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_JobCategory__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_JobCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_JobCategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_BlogHome__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_BlogHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_BlogHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_BlogDetails__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_BlogDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_BlogDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_JobSearch__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_JobSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_JobSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_JobSingle__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_JobSingle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_JobSingle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_PricingPlan__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_PricingPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_PricingPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Elements__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_Elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_Elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_detail__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Service__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_Service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_Service__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_new_home___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_About___default.a
  }, {
    path: '/solution',
    name: 'solution',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Solution___default.a
  }, {
    path: '/product',
    name: 'product',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Product___default.a
  }, {
    path: '/category',
    name: 'category',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_JobCategory___default.a
  }, {
    path: '/blog',
    name: 'blog',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_BlogHome___default.a
  }, {
    path: '/blogDetails',
    name: 'blogDetails',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_BlogDetails___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_ContactUs___default.a
  }, {
    path: '/jobSearch',
    name: 'jobSearch',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_JobSearch___default.a
  }, {
    path: '/jobSingle',
    name: 'jobSingle',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_JobSingle___default.a
  }, {
    path: '/pricingPlan',
    name: 'pricingPlan',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_PricingPlan___default.a
  }, {
    path: '/elements',
    name: 'elements',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_Elements___default.a
  }, {
    path: '/detail',
    name: 'detail',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_detail___default.a
  }, {
    path: '/service',
    name: 'service',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_Service___default.a
  }]
}));

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  modules: {}
}));

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */,
/* 115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)
__webpack_require__(245)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  "data-v-07264466",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_request__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(7);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      status: false,
      menuList: [],
      currentIndex: 0,
      list: {
        position1: [],
        position2: [],
        position3: [],
        position4: []

      },
      psrmas: 'www.kingunit.com'
    };
  },
  mounted: function mounted() {
    this.getMenu();
  },

  methods: {
    getMenu: function getMenu() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4_axios__["a" /* default */].get("http://cms.saveus.cn/api/ttg/columns?domain=" + _this.psrmas).then(function (res) {
                  _this.menuList = res.data.data;
                  _this.getus(_this.menuList[0].id);
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getus: function getus(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;
        for (var index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            _this2.list.position1.push(list[index]);
          } else if (list[index].position == 2) {
            _this2.list.position2.push(list[index]);
          } else if (list[index].position == 3) {
            _this2.list.position3.push(list[index]);
          } else if (list[index].position == 4) {
            _this2.list.position4.push(list[index]);
          }
        }
      });
    },
    routerlinkClick: function routerlinkClick(item, index) {
      if (item.children.length > 0) {
        return;
      }

      this.list.position1 = [];
      this.list.position2 = [];
      this.list.position3 = [];
      this.list.position4 = [];
      if (item.note === "article") {
        this.$router.push({
          path: "detail",
          query: {
            id: item.id,
            source: "article"
          }
        });
      } else {
        this.$router.push({
          path: item.note,
          query: {
            id: item.id
          }
        });
      }
      this.currentIndex = index;
      this.getus(item.id);
    },
    getStyle: function getStyle(index) {
      if (this.currentIndex === index) {
        return {
          color: '#ff9902'
        };
      }
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      solutionlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: []
      }
    };
  },
  mounted: function mounted() {
    this.getus(this.$route.query.id);
  },

  methods: {
    getus: function getus(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;
        for (var index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            _this.solutionlist.position1.push(list[index]);
          } else if (list[index].position == 2) {
            _this.solutionlist.position2.push(list[index]);
          } else if (list[index].position == 3) {
            list[index].status1 = false;
            _this.solutionlist.position3.push(list[index]);
          } else if (list[index].position == 4) {
            _this.solutionlist.position4.push(list[index]);
          }
        }
      });
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      currentPage4: 0,
      index: 0,
      total: 0,
      searchPanel: {
        type: 1,
        page: 1,
        page_size: 4,
        position: 3,
        id: ''
      },
      jobSearchlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: []

      },
      position3: [],
      tabList: []

    };
  },
  mounted: function mounted() {
    this.searchPanel.id = this.$route.query.id;
    this.getus(this.$route.query.id);
    this.getOptions();
    this.getPageList();
  },

  methods: {
    switchTab: function switchTab(index, item) {
      var value = JSON.parse(item.setting);
      this.searchPanel.type = value.value;
      this.searchPanel.page = 1;
      this.index = index;
      this.getPageList();
    },
    detailClick: function detailClick(id) {
      console.log('2');
      this.$router.push({
        path: '/detail',
        query: {
          id: id
        }
      });
    },
    getStyle: function getStyle(index) {
      if (this.index === index) {
        return {
          color: '#ff9902'
        };
      }
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.searchPanel.page = page;
      this.getPageList();
    },
    getPageList: function getPageList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page/list', {
        params: this.searchPanel
      }).then(function (res) {
        _this.position3 = res.data.data.list;
        _this.total = res.data.data.total;
      });
    },
    getOptions: function getOptions() {
      var _this2 = this;

      var id = '244';
      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn//api/ttg/options?id=' + id).then(function (res) {
        _this2.tabList = res.data.data;
      });
    },
    getus: function getus(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;

        for (var index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            _this3.jobSearchlist.position1.push(list[index]);
          } else if (list[index].position == 2) {
            _this3.jobSearchlist.position2.push(list[index]);
          } else if (list[index].position == 3) {
            list[index].status1 = false;
            _this3.jobSearchlist.position3.push(list[index]);
          } else if (list[index].position == 4) {
            _this3.jobSearchlist.position4.push(list[index]);
          }
        }
      });
    }
  }

});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      solutionlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: []
      }
    };
  },

  components: {},
  methods: {
    getus: function getus(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;

        for (var index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            _this.solutionlist.position1.push(list[index]);
          } else if (list[index].position == 2) {
            _this.solutionlist.position2.push(list[index]);
          } else if (list[index].position == 3) {
            list[index].status1 = false;
            _this.solutionlist.position3.push(list[index]);
          } else if (list[index].position == 4) {
            _this.solutionlist.position4.push(list[index]);
          }
        }
      });
    }
  },
  mounted: function mounted() {
    this.getus(this.$route.query.id);
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      pricingPlanlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: []
      }
    };
  },
  mounted: function mounted() {
    this.getus(this.$route.query.id);
  },

  methods: {
    detailClick: function detailClick(id) {},
    getus: function getus(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;

        for (var index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            _this.pricingPlanlist.position1.push(list[index]);
          } else if (list[index].position == 2) {
            _this.pricingPlanlist.position2.push(list[index]);
          } else if (list[index].position == 3) {
            list[index].status1 = false;
            _this.pricingPlanlist.position3.push(list[index]);
          } else if (list[index].position == 4) {
            _this.pricingPlanlist.position4.push(list[index]);
          }
        }
      });
    }
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['list'],
  data: function data() {
    return {
      image: [{ src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_04.jpg', lable: '绿色储能', title: '知安云1', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智能充电', title: '知安云2', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智慧家电', title: '知安云3', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_04.jpg', lable: '智能交通', title: '知安云4', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智能充电', title: '知安云5', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_05.jpg', lable: '智慧家电', title: '知安云6', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }],
      solutionlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: []
      }
    };
  },
  mounted: function mounted() {
    this.getus(this.$route.query.id);
  },

  methods: {
    mouseOver: function mouseOver(item) {
      item.status1 = true;
    },
    mouseLeave: function mouseLeave(item) {
      item.status1 = false;
    },
    openDetail: function openDetail(item) {
      window.open("/detail?id=" + item.id, "_black");
    },
    getus: function getus(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;
        for (var index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            _this.solutionlist.position1.push(list[index]);
          } else if (list[index].position == 2) {
            _this.solutionlist.position2.push(list[index]);
          } else if (list[index].position == 3) {
            list[index].status1 = false;
            _this.solutionlist.position3.push(list[index]);
          } else if (list[index].position == 4) {
            _this.solutionlist.position4.push(list[index]);
          }
        }
      });
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['list'],

  data: function data() {
    return {
      image: [{ src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_04.jpg', lable: '绿色储能', title: '知安云1', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智能充电', title: '知安云2', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智慧家电', title: '知安云3', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_04.jpg', lable: '智能交通', title: '知安云4', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智能充电', title: '知安云5', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_05.jpg', lable: '智慧家电', title: '知安云6', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }],
      solutionlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: []

      }
    };
  },
  mounted: function mounted() {
    this.getus(this.$route.query.id);
  },

  methods: {
    mouseOver: function mouseOver(item) {
      item.status1 = true;
    },
    mouseLeave: function mouseLeave(item) {
      item.status1 = false;
    },
    getus: function getus(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;
        for (var index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            _this.solutionlist.position1.push(list[index]);
          } else if (list[index].position == 2) {
            _this.solutionlist.position2.push(list[index]);
          } else if (list[index].position == 3) {
            list[index].status1 = false;
            _this.solutionlist.position3.push(list[index]);
          } else if (list[index].position == 4) {
            _this.solutionlist.position4.push(list[index]);
          }
        }
      });
    }
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['list'],

  data: function data() {
    return {
      image: [{ src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_04.jpg', lable: '绿色储能', title: '知安云1', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智能充电', title: '知安云2', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智慧家电', title: '知安云3', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_04.jpg', lable: '智能交通', title: '知安云4', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_03.jpg', lable: '智能充电', title: '知安云5', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }, { src: 'http://www.battery-doctor.cn/statics/web/upimg/lnpt_05.jpg', lable: '智慧家电', title: '知安云6', status: false, name: '绿电来操作系统是美克生开发的一套面向新型电力系统的数字孪生平台，它基于物联网、边缘计算、云计算、移动计算、大数据、人工智能、区块链等众多new ICT技术， 不仅涵盖新能源发电、配电、用电、电化学储能、充电等设备；更可对源网荷储充协同优化、电力交易、绿电认证等进行分析；也可以对电池簇、电池箱和电芯单体进行三个层级的健康状态诊断、预测，并给出优化运维策略。 3D、互动网页展示，支持新型电力系统的规划设计、建造、运营、运维等全业务流程的闭环管理，为客户带来降本、增效、提质和绿色论证的价值创造。' }],
      solutionlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: []

      }
    };
  },
  mounted: function mounted() {
    this.getus(this.$route.query.id);
  },

  methods: {
    mouseOver: function mouseOver(item) {
      item.status1 = true;
    },
    mouseLeave: function mouseLeave(item) {
      item.status1 = false;
    },
    getus: function getus(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;
        for (var index = 0; index < list.length; index++) {
          if (list[index].position == 1) {
            _this.solutionlist.position1.push(list[index]);
          } else if (list[index].position == 2) {
            _this.solutionlist.position2.push(list[index]);
          } else if (list[index].position == 3) {
            list[index].status1 = false;
            _this.solutionlist.position3.push(list[index]);
          } else if (list[index].position == 4) {
            _this.solutionlist.position4.push(list[index]);
          }
        }
      });
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      detailDatda: {}
    };
  },

  watch: {
    $route: {
      handler: function handler(val, oldVal) {
        this.getContent(val.query);
      }
    }
  },
  mounted: function mounted() {
    this.getContent(this.$route.query);
  },

  methods: {
    getContent: function getContent(params) {
      if (!!params.source) {
        if (params.source === "article") {
          this.getArticleId(params.id);
        } else {
          this.getDetail(params.id);
        }
      } else {
        this.getDetail(params.id);
      }
    },
    getDetail: function getDetail(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/detail?id=' + id).then(function (res) {
        _this.detailDatda = res.data.data;
      });
    },
    getArticleId: function getArticleId(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/page?id=' + id).then(function (res) {
        var list = res.data.data;
        if (list.length > 0) {
          __WEBPACK_IMPORTED_MODULE_1_axios__["a" /* default */].get('http://cms.saveus.cn/api/ttg/detail?id=' + list[0].id).then(function (res) {
            _this2.detailDatda = res.data.data;
          });
        } else {
          _this2.detailDatda = {};
        }
      });
    }
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_index__ = __webpack_require__(10);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['list', 'menuList'],
  data: function data() {
    return {
      http: window.location.href
    };
  },
  mounted: function mounted() {},

  methods: {
    detailClick: function detailClick(id) {},
    getus: function getus(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_index__["a" /* us */])({ id: id }).then(function (res) {
                  _this.list = res.data;
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qs__);










__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export baseUrl */
var baseUrl = '/api';


/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  "data-v-44aa54ae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  "data-v-5e011466",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  "data-v-826239f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  "data-v-6a8c5ed0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(250)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  "data-v-50840596",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  "data-v-0b7685e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  "data-v-4964f260",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  "data-v-311b63bb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header-area single-page"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', _vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        mainmenuli: !(item.children.length > 0)
      }
    }, [_c('a', {
      staticStyle: {
        "font-size": "20px"
      },
      style: (_vm.getStyle(index)),
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.routerlinkClick(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.children.length > 0) ? _c('ul', {
      staticClass: "sub-menu"
    }, _vm._l((item.children), function(childrenItem, index) {
      return _c('li', {
        key: index,
        staticClass: "mainmenuli"
      }, [_c('a', {
        staticStyle: {
          "font-size": "18px",
          "font-weight": "normal"
        },
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.routerlinkClick(childrenItem)
          }
        }
      }, [_vm._v(_vm._s(childrenItem.name))])])
    }), 0) : _vm._e()])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "conent_box"
  }, [_c('router-view', {
    attrs: {
      "list": _vm.list,
      "menuList": _vm.menuList
    }
  })], 1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo-area"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "auto"
    },
    attrs: {
      "src": "static/assets/images/kunyu_logo.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-area section-padding"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3 col-lg-3"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 zuoyou"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("售前咨询热线:")]), _vm._v(" "), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("+86-21-67631999")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-5 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 lianix"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_c('span', [_vm._v("上海坤瑀智能科技有限公司")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('span', [_vm._v("地址：上海：崇明区兴奔路66号")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("            北京：丰台区马家堡西路15号1区21层")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("            天津：西青经济技术开发区兴华三支路5号E1座")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("电话：+86-21-67631999")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-2"
  }, [_c('div', {
    staticClass: "single-widge-home chengxu"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("公众号")]), _vm._v(" "), _c('div', {
    staticClass: "feed",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "static/assets/images/kunyu_qrcode.png",
      "alt": "feed"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-2"
  }, [_c('div', {
    staticClass: "single-widge-home chengxu"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("移动端")]), _vm._v(" "), _c('div', {
    staticClass: "feed",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "static/assets/images/kunyu_m_qrcode.png",
      "alt": "feed"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-6",
    staticStyle: {
      "text-align": "center",
      "font-size": "1.5vh"
    }
  }, [_c('span', [_vm._v("Copyright ©上海坤瑀智能科技有限公司")])])])])])])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.solutionlist.position1.length > 0) ? _c('div', {
    staticClass: "bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.solutionlist.position1[0].thumb
    }
  }), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position1[0].title))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position2.length > 0) ? _c('div', {
    staticClass: "bbox"
  }, [_c('div', {
    staticClass: "row max_box"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', [_c('img', {
    staticClass: "bg-style",
    attrs: {
      "src": _vm.solutionlist.position2[0].thumb
    }
  })])]), _vm._v(" "), (_vm.solutionlist.position2.length > 1) ? _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box_name"
  }, [_c('h3', {
    staticClass: "h1_title"
  }, [_vm._v(_vm._s(_vm.solutionlist.position2[1].title))]), _vm._v(" "), _c('div', {
    staticClass: "bor_bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_box_width"
  }, [_vm._v("\n            " + _vm._s(_vm.solutionlist.position2[1].brief) + "\n          ")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position3.length > 0) ? _c('div', {
    staticClass: "col-img-height",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.solutionlist.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-2 p-r",
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": function($event) {
          return _vm.mouseLeave(item)
        }
      }
    }, [(index < 6) ? _c('div', [_c('img', {
      staticClass: "p-r-img",
      staticStyle: {
        "width": "100%",
        "height": "60vh",
        "border": "1px solid #fff"
      },
      attrs: {
        "src": item.thumb,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-a-lable"
    }, [_c('span', {
      staticStyle: {
        "background": "#f8b600",
        "padding-top": "5px",
        "padding-bottom": "5px"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status1),
        expression: "item.status1"
      }],
      staticClass: "p-a"
    }, [_c('h2', {
      staticStyle: {
        "width": "100%",
        "text-align": "center",
        "color": "#fff",
        "margin-top": "30px",
        "font-size": "2vh"
      }
    }, [_vm._v(_vm._s(item.title) + "\n            ")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "padding": "10px",
        "white-space": "pre-wrap"
      }
    }, [_vm._v(_vm._s(item.brief))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position4.length > 0) ? _c('div', {
    staticClass: "bbox-top"
  }, [_c('div', {
    staticClass: "row max_box"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.solutionlist.position4[0] != undefined) ? _c('div', {
    staticClass: "bbox-top_name"
  }, [_c('h3', {
    staticClass: "h1_title"
  }, [_vm._v(_vm._s(_vm.solutionlist.position4[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "bor_bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_box_width"
  }, [_vm._v("\n            " + _vm._s(_vm.solutionlist.position4[0].brief) + "\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.solutionlist.position4[0] != undefined) ? _c('div', {
    staticClass: "bbox-top-bg-style"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "min-height": "36vh"
    },
    attrs: {
      "src": _vm.solutionlist.position4[0].thumb
    }
  })]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "map-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "mapBox",
    attrs: {
      "id": "mapBox",
      "data-lat": "40.701083",
      "data-lon": "-74.1522848",
      "data-zoom": "13",
      "data-info": "PO Box CT16122 Collins Street West, Victoria 8007, Australia.",
      "data-mlat": "40.701083",
      "data-mlon": "-74.1522848"
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "contact-form section-padding3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 mb-5 mb-lg-0"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "into-icon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('h4', [_vm._v("California, United States")]), _vm._v(" "), _c('p', [_vm._v("Santa monica bullevard")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "into-icon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('h4', [_vm._v("00 (440) 9865 562")]), _vm._v(" "), _c('p', [_vm._v("Mon to Fri 9am to 6 pm")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "into-icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_c('h4', [_vm._v("support@colorlib.com")]), _vm._v(" "), _c('p', [_vm._v("Send us your query anytime!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter your name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter your name'",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter email address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter email address'",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter subject",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter subject'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    attrs: {
      "name": "message",
      "cols": "20",
      "rows": "7",
      "placeholder": "Enter Message",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter Message'",
      "required": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("subscribe now")])])])])])])])
}]}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-heart"
  }), _vm._v("\t4 likes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-bubble"
  }), _vm._v(" 06 Comments")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-heart"
  }), _vm._v("\t4 likes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-bubble"
  }), _vm._v(" 06 Comments")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p3.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-heart"
  }), _vm._v("\t4 likes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-bubble"
  }), _vm._v(" 06 Comments")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p4.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology, ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-meta"
  }, [_c('div', {
    staticClass: "user-details row align-items-center"
  }, [_c('div', {
    staticClass: "comment-wrap col-lg-6"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-heart"
  }), _vm._v("\t4 likes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "lnr lnr-bubble"
  }), _vm._v(" 06 Comments")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 sidebar"
  }, [_c('div', {
    staticClass: "single-widget search-widget"
  }, [_c('form', {
    staticClass: "example",
    staticStyle: {
      "margin": "auto",
      "max-width": "300px"
    },
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Posts",
      "name": "search2",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Search Posts'",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget protfolio-widget"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/user2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h4', [_vm._v("Adele Gonzalez")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and\n              its detractors. Some people do not understand why you should have to spend money\n              on boot camp.\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dribbble"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-behance"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget category-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Post Categories")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Techlology")]), _vm._v(" "), _c('span', [_vm._v("37")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Lifestyle")]), _vm._v(" "), _c('span', [_vm._v("24")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Fashion")]), _vm._v(" "), _c('span', [_vm._v("59")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Art")]), _vm._v(" "), _c('span', [_vm._v("29")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Food")]), _vm._v(" "), _c('span', [_vm._v("15")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Architecture")]), _vm._v(" "), _c('span', [_vm._v("09")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Adventure")]), _vm._v(" "), _c('span', [_vm._v("44")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget recent-posts-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Recent Posts")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list"
  }, [_c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r2.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r3.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r4.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget category-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Post Archive")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Dec '17")]), _vm._v(" "), _c('span', [_vm._v("37")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Nov '17")]), _vm._v(" "), _c('span', [_vm._v("24")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Oct '17")]), _vm._v(" "), _c('span', [_vm._v("59")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Sep '17")]), _vm._v(" "), _c('span', [_vm._v("29")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Aug '17")]), _vm._v(" "), _c('span', [_vm._v("15")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Jul '17")]), _vm._v(" "), _c('span', [_vm._v("09")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Jun '17")]), _vm._v(" "), _c('span', [_vm._v("44")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget tags-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Tag Clouds")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lifestyle")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Adventure")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Techlology")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Architecture")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology")])])])])])])])])])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "banner-area"
  }, [_c('el-carousel', {
    staticStyle: {
      "width": "100%",
      "z-index": "1"
    },
    attrs: {
      "interval": 5000,
      "trigger": "click",
      "height": "70vh"
    }
  }, _vm._l((_vm.list.position1), function(item, index) {
    return _c('el-carousel-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.list.position1.length > 0),
        expression: "list.position1.length>0"
      }],
      key: index
    }, [_c('div', {
      staticClass: "banner-area-img",
      style: ({
        width: '100%',
        height: '100%',
        'background-image': 'url(' + item.thumb + ')',
        'background-repeat': 'no-repeat',
        'background-size': '100% 100%'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "new-banner-text"
    }, [_c('div', {
      staticClass: "new-banner-title"
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v(_vm._s(item.brief))])]), _vm._v(" "), (item.content != null) ? _c('div', {
      staticClass: "new-banner-brief",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }) : _vm._e()])])
  }), 1)], 1), _vm._v(" "), (_vm.list.position2.length > 0) ? _c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "banner-item"
  }, [_c('div', {
    staticClass: "row max-height"
  }, [_c('div', {
    staticClass: "col-lg-3 offset-xl-1 align-self-center"
  }, [_c('div', {
    staticClass: "banner-about color-content"
  }, [_c('h2', {
    staticClass: "color-title"
  }, [_vm._v("Solution")]), _vm._v(" "), _c('h2', {
    staticClass: "color-title"
  }, [_vm._v("解决方案")]), _vm._v(" "), _c('b', {
    staticClass: "slot-about"
  }), _vm._v(" "), (_vm.list.position2.length > 0) ? _c('p', {
    staticClass: "py-3"
  }, [_vm._v(_vm._s(_vm.list.position2[0].brief))]) : _vm._e(), _vm._v(" "), (_vm.list.position2.length > 0) ? _c('el-button', {
    staticStyle: {
      "background-color": "#232126",
      "color": "#FFFFFF",
      "border": "1px solid #999999"
    },
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[0].id)
      }
    }
  }, [_vm._v("查看更多")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 px-5"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.list.position2.length > 1) ? _c('div', {
    staticClass: "col-lg-5 align-self-center",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[1].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi1",
    staticStyle: {
      "padding": "0px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": _vm.list.position2[1].thumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-content position2"
  }, [_c('h4', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "2vh"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[1].title))]), _vm._v(" "), _c('p', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "1.5vh",
      "width": "95%"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[1].brief))])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position2.length > 2) ? _c('div', {
    staticClass: "col-lg-5 align-self-center",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[2].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi1",
    staticStyle: {
      "padding": "0px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": _vm.list.position2[2].thumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-content position2"
  }, [_c('h4', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "2vh"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[2].title))]), _vm._v(" "), _c('p', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "1.5vh",
      "width": "95%"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[2].brief))])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position2.length > 3) ? _c('div', {
    staticClass: "col-lg-5 align-self-center",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[3].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi1",
    staticStyle: {
      "padding": "0px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": _vm.list.position2[3].thumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-content position2"
  }, [_c('h4', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "2vh"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[3].title))]), _vm._v(" "), _c('p', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "1.5vh",
      "width": "95%"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[3].brief))])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position2.length > 4) ? _c('div', {
    staticClass: "col-lg-5 align-self-center",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.list.position2[4].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi1",
    staticStyle: {
      "padding": "0px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": _vm.list.position2[4].thumb
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-content position2"
  }, [_c('h4', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "2vh"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[4].title))]), _vm._v(" "), _c('p', {
    staticClass: "color-about-foot",
    staticStyle: {
      "font-size": "1.5vh",
      "width": "95%"
    }
  }, [_vm._v(_vm._s(_vm.list.position2[4].brief))])])])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position3.length > 0) ? _c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "banner-three"
  }, [_c('div', {
    staticClass: "banner-compony-layout"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "3vh",
      "color": "#fff",
      "font-style": "italic"
    }
  }, [_vm._v(_vm._s(_vm.list.position3[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 align-self-center"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 banner-compony-content"
  }, [_c('p', {
    staticStyle: {
      "padding": "10px",
      "text-indent": "2em"
    }
  }, [_vm._v(_vm._s(_vm.list.position3[0].brief) + " ")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 offset-xl-6 align-self-center"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0 chengshi2",
    staticStyle: {
      "height": "35vh"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.list.position3[0].thumb
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.list.position4.length > 0) ? _c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "banner-four top_img"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.list.position4[0].thumb
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn color-about",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "flaticon-next"
  })])
}]}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "job-single-content section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "jobs-tab tab-item"
  }, [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_vm._v("recent")]), _vm._v(" "), _c('li', [_vm._v("full time")]), _vm._v(" "), _c('li', [_vm._v("part time")]), _vm._v(" "), _c('li', [_vm._v("intern")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "single-content1"
  }, [_c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Assistant Executive - Production/ Quality Control")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job1.png",
      "alt": "job"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Asst. Manager, Production (Woven Dyeing)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job2.png",
      "alt": "job"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Deputy Manager/ Assistant Manager - Footwear")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job3.png",
      "alt": "job"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("R&D Manager (Technical Lab Department)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job4.png",
      "alt": "job"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Manager/ Asst. Manager (Quality Assurance)")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job5.png",
      "alt": "job"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "single-job d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("Deputy Manager/ Assistant Manager - Footwear")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job3.png",
      "alt": "job"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "more-job-btn mt-5 text-center"
  }, [_c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("more job post")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "sidebar mt-5 mt-lg-0"
  }, [_c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("jobs type")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Full Time")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Part Time")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Internship")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("job by location")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("New York")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("California")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Swizerland")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Canada")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Sweden")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item mb-4"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("salary range")]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$20,000-$30,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between mb-3",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$25,000-$45,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])]), _vm._v(" "), _c('a', {
    staticClass: "sidebar-btn d-flex justify-content-between",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("$40,000-$70,000")]), _vm._v(" "), _c('span', {
    staticClass: "text-right"
  }, [_vm._v("25 job")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-item"
  }, [_c('h4', {
    staticClass: "mb-4"
  }, [_vm._v("filter by salary")])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "newsletter-area job-single section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("Get job information daily")]), _vm._v(" "), _c('p', [_vm._v("Subscribe to our newsletter and get a coupon code!")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Your email here",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Your email here'",
      "required": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("subscribe now")])])])])])])])
}]}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "about-bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.solutionlist.position1.length > 0) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.solutionlist.position1[0].thumb
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position1[0].title))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "banner-area"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-xl-1 align-self-center"
  }, [_c('div', {
    staticClass: "banner-about color-about"
  }, [(_vm.solutionlist.position2.length > 0) ? _c('h2', {
    staticClass: "color-about",
    staticStyle: {
      "font-size": "2.5vh"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position2[0].title))]) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "slot-about"
  }), _vm._v(" "), (_vm.solutionlist.position2.length > 0) ? _c('p', {
    staticClass: "py-3",
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position2[0].brief))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 px-0",
    staticStyle: {
      "padding": "1px"
    }
  }, [(_vm.solutionlist.position2.length > 1) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "40vh"
    },
    attrs: {
      "src": _vm.solutionlist.position2[1].thumb,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.solutionlist.position3.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h4', {
    staticClass: "color-about"
  }, [_vm._v(" " + _vm._s(_vm.solutionlist.position3[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-3 text-left color-about",
    staticStyle: {
      "font-style": "unset",
      "text-indent": "2em"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[0].brief) + "\n            ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.solutionlist.position3.length > 1) ? _c('div', {
    staticClass: "single-feature mb-4 mb-lg-0",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[1].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[1].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[1].brief))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [(_vm.solutionlist.position3.length > 2) ? _c('div', {
    staticClass: "single-feature mb-4 mb-lg-4",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[2].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[2].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[2].brief))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.solutionlist.position3.length > 3) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-4",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[3].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[3].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[3].brief))])])]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position3.length > 4) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-4",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[4].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[4].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[4].brief))])])]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position3.length > 5) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-4",
    style: ({
      backgroundImage: 'url(' + _vm.solutionlist.position3[5].thumb + ')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      height: '20vh'
    })
  }, [_c('h4', {
    staticClass: "color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[5].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-0 color-about-foot"
  }, [_vm._v(_vm._s(_vm.solutionlist.position3[5].brief))])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-11 offset-xl-1"
  }, [_c('div', {
    staticClass: "foot-banner"
  })])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "26vh"
    },
    attrs: {
      "src": "static/assets/images/shouye_bg.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 detail_title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.detailDatda.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 detail_brief"
  }, [(_vm.detailDatda.content != null) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detailDatda.content)
    }
  }) : _c('div', [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.solutionlist.position1.length > 0) ? _c('div', {
    staticClass: "bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.solutionlist.position1[0].thumb
    }
  }), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position1[0].title))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position2.length > 0) ? _c('div', {
    staticClass: "bbox"
  }, [_c('div', {
    staticClass: "row max_box"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', [_c('img', {
    staticClass: "bg-style",
    attrs: {
      "src": _vm.solutionlist.position2[0].thumb
    }
  })])]), _vm._v(" "), (_vm.solutionlist.position2.length > 1) ? _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box_name"
  }, [_c('h3', {
    staticClass: "h1_title"
  }, [_vm._v(_vm._s(_vm.solutionlist.position2[1].title))]), _vm._v(" "), _c('div', {
    staticClass: "bor_bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_box_width"
  }, [_vm._v("\n            " + _vm._s(_vm.solutionlist.position2[1].brief) + "\n          ")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position3.length > 0) ? _c('div', {
    staticClass: "col-img-height",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.solutionlist.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-2 p-r",
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": function($event) {
          return _vm.mouseLeave(item)
        }
      }
    }, [(index < 6) ? _c('div', [_c('img', {
      staticClass: "p-r-img",
      staticStyle: {
        "width": "100%",
        "height": "60vh",
        "border": "1px solid #fff"
      },
      attrs: {
        "src": item.thumb,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-a-lable"
    }, [_c('span', {
      staticStyle: {
        "background": "#f8b600",
        "padding-top": "5px",
        "padding-bottom": "5px"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status1),
        expression: "item.status1"
      }],
      staticClass: "p-a"
    }, [_c('h2', {
      staticStyle: {
        "width": "100%",
        "text-align": "center",
        "color": "#fff",
        "margin-top": "30px",
        "font-size": "2vh"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "padding": "10px",
        "white-space": "pre-wrap"
      }
    }, [_vm._v(_vm._s(item.brief))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position4.length > 0) ? _c('div', {
    staticClass: "bbox-top"
  }, [_c('div', {
    staticClass: "row max_box"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.solutionlist.position4[0] != undefined) ? _c('div', {
    staticClass: "bbox-top_name"
  }, [_c('h3', {
    staticClass: "h1_title"
  }, [_vm._v(_vm._s(_vm.solutionlist.position4[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "bor_bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_box_width"
  }, [_vm._v("\n            " + _vm._s(_vm.solutionlist.position4[0].brief) + "\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.solutionlist.position4[0] != undefined) ? _c('div', {
    staticClass: "bbox-top-bg-style"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "min-height": "36vh"
    },
    attrs: {
      "src": _vm.solutionlist.position4[0].thumb
    }
  })]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jobSearch-bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.jobSearchlist.position1.length > 0) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.jobSearchlist.position1[0].thumb
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position1[0].title))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "jobs-area section-padding3",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.jobSearchlist.position1.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "jobs-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.jobSearchlist.position1[0].title))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "jobs-tab tab-item"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "nav-item"
    }, [_c('a', {
      staticClass: "nav-link",
      style: (_vm.getStyle(index)),
      attrs: {
        "data-toggle": "tab"
      },
      on: {
        "click": function($event) {
          return _vm.switchTab(index, item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [(_vm.index == 0) ? _c('div', {
    staticClass: "tab-pane fade show active"
  }, [_c('div', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.jobSearchlist.position2.length > 0) ? _c('div', {
    staticClass: "single-feature mb-4 mb-lg-0",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.jobSearchlist.position2[0].id)
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "height": "50%",
      "src": "static/assets/images/banner-bg.jpg"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].created_at))]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-1 no-margin"
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].brief))]), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, _vm._l((_vm.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "single-feature mb-4 mb-lg-3",
      on: {
        "click": function($event) {
          return _vm.detailClick(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-3",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticStyle: {
        "align-self": "center"
      },
      attrs: {
        "width": "100%",
        "height": "50%",
        "src": item.thumb
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9"
    }, [_c('h2', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "py-1 no-margin"
    }, [_vm._v(_vm._s(item.brief))]), _vm._v(" "), _vm._m(1, true)])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.index == 1) ? _c('div', {
    staticClass: "tab-pane fade show active"
  }, [_c('div', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.jobSearchlist.position2.length > 0) ? _c('div', {
    staticClass: "col-lg-6",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.jobSearchlist.position2[0].id)
      }
    }
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "height": "50%",
      "src": "static/assets/images/banner-bg.jpg"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].created_at))]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-1 no-margin"
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].brief))]), _vm._v(" "), _vm._m(2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, _vm._l((_vm.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "single-feature mb-4 mb-lg-3",
      on: {
        "click": function($event) {
          return _vm.detailClick(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-3",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticStyle: {
        "align-self": "center"
      },
      attrs: {
        "width": "100%",
        "height": "50%",
        "src": item.thumb
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9"
    }, [_c('h2', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "py-1 no-margin"
    }, [_vm._v(_vm._s(item.brief))]), _vm._v(" "), _vm._m(3, true)])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.index == 2) ? _c('div', {
    staticClass: "tab-pane fade show active"
  }, [_c('div', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.jobSearchlist.position2.length > 0) ? _c('div', {
    staticClass: "single-feature mb-4 mb-lg-0",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.jobSearchlist.position2[0].id)
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "height": "50%",
      "src": "static/assets/images/banner-bg.jpg"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].created_at))]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-1 no-margin"
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].brief))]), _vm._v(" "), _vm._m(4)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, _vm._l((_vm.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "single-feature mb-4 mb-lg-3",
      on: {
        "click": function($event) {
          return _vm.detailClick(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-3",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticStyle: {
        "align-self": "center"
      },
      attrs: {
        "width": "100%",
        "height": "50%",
        "src": item.thumb
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9"
    }, [_c('h2', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "py-1 no-margin"
    }, [_vm._v(_vm._s(item.brief))]), _vm._v(" "), _vm._m(5, true)])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.index == 3) ? _c('div', {
    staticClass: "tab-pane fade show active"
  }, [_c('div', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.jobSearchlist.position2.length > 0) ? _c('div', {
    staticClass: "single-feature mb-4 mb-lg-0",
    on: {
      "click": function($event) {
        return _vm.detailClick(_vm.jobSearchlist.position2[0].id)
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "height": "50%",
      "src": "static/assets/images/banner-bg.jpg"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].created_at))]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "py-1 no-margin"
  }, [_vm._v(_vm._s(_vm.jobSearchlist.position2[0].brief))]), _vm._v(" "), _vm._m(6)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, _vm._l((_vm.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "single-feature mb-4 mb-lg-3",
      on: {
        "click": function($event) {
          return _vm.detailClick(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-3",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticStyle: {
        "align-self": "center"
      },
      attrs: {
        "width": "100%",
        "height": "50%",
        "src": item.thumb
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-9"
    }, [_c('h2', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "py-1 no-margin"
    }, [_vm._v(_vm._s(item.brief))]), _vm._v(" "), _vm._m(7, true)])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.index == 4) ? _c('div', {
    staticClass: "tab-pane fade show active"
  }, [_vm._m(8)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 text-right"
  }, [_c('el-pagination', {
    staticStyle: {
      "white-space": "pre-line"
    },
    attrs: {
      "current-page": _vm.currentPage4,
      "page-size": 4,
      "total": Number(_vm.total)
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("立即了解"), _c('span', {
    staticClass: "flaticon-next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn btn-position-right",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("立即了解"), _c('span', {
    staticClass: "flaticon-next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("立即了解"), _c('span', {
    staticClass: "flaticon-next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn btn-position-right",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("立即了解"), _c('span', {
    staticClass: "flaticon-next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("立即了解"), _c('span', {
    staticClass: "flaticon-next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn btn-position-right",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("立即了解"), _c('span', {
    staticClass: "flaticon-next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("立即了解"), _c('span', {
    staticClass: "flaticon-next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "secondary-btn btn-position-right",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("立即了解"), _c('span', {
    staticClass: "flaticon-next"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v("测试v-if")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" new yourk, USA")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v("\n                        Applied Chemistry & Chemical Engineering / Chemistry")])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Deadline Deadline: Dec 11, 2018")])])])]), _vm._v(" "), _c('div', {
    staticClass: "job-img align-self-center"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/job4.png",
      "alt": "job"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "third-btn job-btn4",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("full time")]), _vm._v(" "), _c('a', {
    staticClass: "third-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("apply")])])])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.solutionlist.position1.length > 0) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.solutionlist.position1[0].thumb
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position1[0].title))]) : _vm._e()]), _vm._v(" "), (_vm.solutionlist.position2.length > 0) ? _c('div', {
    staticClass: "bbox"
  }, [_c('div', {
    staticClass: "row max_box"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', [_c('img', {
    staticClass: "bg-style",
    attrs: {
      "src": _vm.solutionlist.position2[0].thumb
    }
  })])]), _vm._v(" "), (_vm.solutionlist.position2.length > 1) ? _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box_name"
  }, [_c('h3', {
    staticClass: "h1_title"
  }, [_vm._v(_vm._s(_vm.solutionlist.position2[1].title))]), _vm._v(" "), _c('div', {
    staticClass: "bor_bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_box_width"
  }, [_vm._v("\n            " + _vm._s(_vm.solutionlist.position2[1].brief) + "\n          ")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position3.length > 0) ? _c('div', {
    staticClass: "col-img-height",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.solutionlist.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-2 p-r",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(item)
        },
        "mouseleave": function($event) {
          return _vm.mouseLeave(item)
        },
        "click": function($event) {
          return _vm.openDetail(item)
        }
      }
    }, [(index < 6) ? _c('div', [_c('img', {
      staticClass: "p-r-img",
      staticStyle: {
        "width": "100%",
        "height": "60vh",
        "border": "1px solid #fff"
      },
      attrs: {
        "src": item.thumb,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "p-a-lable"
    }, [_c('span', {
      staticStyle: {
        "background": "#f8b600",
        "padding-top": "5px",
        "padding-bottom": "5px"
      }
    }, [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status1),
        expression: "item.status1"
      }],
      staticClass: "p-a"
    }, [_c('h2', {
      staticStyle: {
        "width": "100%",
        "text-align": "center",
        "color": "#fff",
        "margin-top": "30px",
        "font-size": "2vh"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "padding": "10px",
        "white-space": "pre-wrap"
      }
    }, [_vm._v(_vm._s(item.brief))])])]) : _vm._e()])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.solutionlist.position4.length > 0) ? _c('div', {
    staticClass: "bbox-top"
  }, [_c('div', {
    staticClass: "row max_box"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.solutionlist.position4[0] != undefined) ? _c('div', {
    staticClass: "bbox-top_name"
  }, [_c('h3', {
    staticClass: "h1_title"
  }, [_vm._v(_vm._s(_vm.solutionlist.position4[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "bor_bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_box_width"
  }, [_vm._v("\n            " + _vm._s(_vm.solutionlist.position4[0].brief) + "\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.solutionlist.position4[0] != undefined) ? _c('div', {
    staticClass: "bbox-top-bg-style"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "min-height": "36vh"
    },
    attrs: {
      "src": _vm.solutionlist.position4[0].thumb
    }
  })]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pricingPlan-bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.pricingPlanlist.position1.length > 0) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.pricingPlanlist.position1[0].thumb
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.pricingPlanlist.position1[0].title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "pricing-box section-padding3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.pricingPlanlist.position2.length > 0) ? _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "background-color": "#F9F9F9",
      "padding": "0 0",
      "margin": "1vh 2vw"
    }
  }, [_c('div', {
    staticClass: "single-box1 text-center mb-4 mb-md-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.pricingPlanlist.position2[0].thumb
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 20px"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.pricingPlanlist.position2[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.pricingPlanlist.position2[0].brief))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100%",
      "display": "flex",
      "align-content": "space-around",
      "align-items": "flex-start",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.pricingPlanlist.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-4"
    }, [(index < 9) ? _c('ul', {
      on: {
        "click": function($event) {
          return _vm.detailClick(item.id)
        }
      }
    }, [_c('li', [_c('img', {
      staticClass: "sass-img",
      attrs: {
        "src": item.thumb
      }
    })]), _vm._v(" "), _c('li', {
      staticClass: "sass_title"
    }, [_vm._v(_vm._s(item.title))])]) : _vm._e()])
  }), 0)])])])])])
},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jobSingle-bottom_img",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.solutionlist.position1.length > 0) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "50vh"
    },
    attrs: {
      "src": _vm.solutionlist.position1[0].thumb
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('p', {
    staticStyle: {
      "position": "absolute",
      "color": "#fff",
      "bottom": "10vh",
      "font-size": "6vh",
      "left": "12%",
      "border-bottom": "2px solid #ccc",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.solutionlist.position1[0].title))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "job-single-content section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "single-content1"
  }, [(_vm.solutionlist.position2.length > 0) ? _c('div', {
    staticClass: "single-job mb-4 d-lg-flex justify-content-between"
  }, [_c('div', {
    staticClass: "job-text"
  }, [_c('h4', [_vm._v(" " + _vm._s(_vm.solutionlist.position2[0].title))]), _vm._v(" "), _c('ul', {
    staticClass: "mt-4"
  }, [_c('li', {
    staticClass: "mb-3"
  }, [_c('h5', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" " + _vm._s(_vm.solutionlist.position2[0].brief))])]), _vm._v(" "), _c('li', [_c('h5', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 最新发布时间:" + _vm._s(_vm.solutionlist.position2[0].created_at))])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "job-btn align-self-center"
  }, [_c('a', {
    staticClass: "forth-btn",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("联系我吧")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.solutionlist.position3), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "single-content4 single-job py-4"
    }, [_c('h4', {
      staticClass: "mobile_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('ul', {
      staticClass: "mobile_ul"
    }, [_c('li', {
      staticClass: "mb-2",
      staticStyle: {
        "white-space": "pre-wrap"
      }
    }, [_vm._v(_vm._s(item.brief))])])])
  })], 2)])])])])])
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('p', [_vm._v("\n                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n              ")]), _vm._v(" "), _c('blockquote', {
    staticClass: "generic-blockquote"
  }, [_vm._v("\n                “Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players”\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n              ")])]), _vm._v(" "), _c('section', {
    staticClass: "nav-area py-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-sm-6 nav-left justify-content-start d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/prev.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "post-details"
  }, [_c('p', [_vm._v("Prev Post")]), _vm._v(" "), _c('h4', {
    staticClass: "text-uppercase"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("A Discount Toner")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 nav-right justify-content-end d-flex"
  }, [_c('div', {
    staticClass: "post-details"
  }, [_c('p', [_vm._v("Prev Post")]), _vm._v(" "), _c('h4', {
    staticClass: "text-uppercase"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("A Discount Toner")])])]), _vm._v(" "), _c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/next.jpg",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('section', {
    staticClass: "comment-sec-area py-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flex-column"
  }, [_c('h5', {
    staticClass: "text-uppercase pb-80"
  }, [_vm._v("05 Comments")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "comment-list"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])]), _vm._v(" "), _c('div', {
    staticClass: "comment-list left-padding"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c2.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])]), _vm._v(" "), _c('div', {
    staticClass: "comment-list left-padding"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c3.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])]), _vm._v(" "), _c('div', {
    staticClass: "comment-list"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c4.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])]), _vm._v(" "), _c('div', {
    staticClass: "comment-list"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c5.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "commentform-area py-5"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter your name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter your name'",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter email address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter email address'",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter subject",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter subject'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    attrs: {
      "name": "message",
      "cols": "20",
      "rows": "7",
      "placeholder": "Enter Message",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter Message'",
      "required": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("subscribe now")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 sidebar mt-5 mt-lg-0"
  }, [_c('div', {
    staticClass: "single-widget search-widget"
  }, [_c('form', {
    staticClass: "example",
    staticStyle: {
      "margin": "auto",
      "max-width": "300px"
    },
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Posts",
      "name": "search2"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget protfolio-widget"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/user2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h4', [_vm._v("Adele Gonzalez")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and\n              its detractors. Some people do not understand why you should have to spend money\n              on boot camp.\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dribbble"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-behance"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget category-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Post Categories")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Techlology")]), _vm._v(" "), _c('span', [_vm._v("37")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Lifestyle")]), _vm._v(" "), _c('span', [_vm._v("24")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Fashion")]), _vm._v(" "), _c('span', [_vm._v("59")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Art")]), _vm._v(" "), _c('span', [_vm._v("29")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Food")]), _vm._v(" "), _c('span', [_vm._v("15")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Architecture")]), _vm._v(" "), _c('span', [_vm._v("09")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Adventure")]), _vm._v(" "), _c('span', [_vm._v("44")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget recent-posts-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Recent Posts")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list"
  }, [_c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r2.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r3.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r4.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget category-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Post Archive")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Dec '17")]), _vm._v(" "), _c('span', [_vm._v("37")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Nov '17")]), _vm._v(" "), _c('span', [_vm._v("24")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Oct '17")]), _vm._v(" "), _c('span', [_vm._v("59")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Sep '17")]), _vm._v(" "), _c('span', [_vm._v("29")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Aug '17")]), _vm._v(" "), _c('span', [_vm._v("15")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Jul '17")]), _vm._v(" "), _c('span', [_vm._v("09")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Jun '17")]), _vm._v(" "), _c('span', [_vm._v("44")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget tags-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Tag Clouds")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lifestyle")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Adventure")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Techlology")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Architecture")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology")])])])])])])])])])
}]}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "sample-text-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("Text Sample")]), _vm._v(" "), _c('p', {
    staticClass: "sample-text"
  }, [_vm._v("\n        Every avid independent filmmaker has "), _c('b', [_vm._v("Bold")]), _vm._v(" about making that "), _c('i', [_vm._v("Italic")]), _vm._v(" interest documentary, or short film to show off their creative prowess. Many have great ideas and want to “wow” the"), _c('sup', [_vm._v("Superscript")]), _vm._v(" scene, or video renters with their big project.  But once you have the"), _c('sub', [_vm._v("Subscript")]), _vm._v(" “in the can” (no easy feat), how do you move from a "), _c('del', [_vm._v("Strike")]), _vm._v(" through of master DVDs with the "), _c('u', [_vm._v("“Underline”")]), _vm._v(" marked hand-written title inside a secondhand CD case, to a pile of cardboard boxes full of shiny new, retail-ready DVDs, with UPC barcodes and polywrap sitting on your doorstep?  You need to create eye-popping artwork and have your project replicated. Using a reputable full service DVD Replication company like PacificDisc, Inc. to partner with is certainly a helpful option to ensure a professional end result, but to help with your DVD replication project, here are 4 easy steps to follow for good DVD replication results:\n\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "button-area"
  }, [_c('div', {
    staticClass: "container border-top-generic"
  }, [_c('h3', {
    staticClass: "text-heading title_color"
  }, [_vm._v("Sample Buttons")]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area"
  }, [_c('a', {
    staticClass: "genric-btn default",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable radius",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn link-border circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn disable circle",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Disable")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn default circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn default-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Primary"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Success"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn info-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Info"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn warning-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Warning"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn danger-border circle arrow",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Danger"), _c('span', {
    staticClass: "lnr lnr-arrow-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-40"
  }, [_c('a', {
    staticClass: "genric-btn primary e-large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Small")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group-area mt-10"
  }, [_c('a', {
    staticClass: "genric-btn primary-border e-large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Extra Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border large",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Large")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn success-border medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('a', {
    staticClass: "genric-btn primary-border small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Small")])])])]), _vm._v(" "), _c('div', {
    staticClass: "whole-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Left Aligned")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 mt-sm-20 left-align-p"
  }, [_c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players found themselves being chased by the Federal government. But, after a fortnight, the online casino industry came up with a solution and new online casinos started taking root. These began to operate under a different business umbrella, and by doing that, rendered the transfer of money to and from them legal. A major part of this was enlisting electronic banking systems that would accept this new clarification and start doing business with me. Listed in this article are the electronic banking systems that accept players from the United States that wish to play in online casinos.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border text-right"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Right Aligned")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('p', {
    staticClass: "text-right"
  }, [_vm._v("Over time, even the most sophisticated, memory packed computer can begin to run slow if we don’t do something to prevent it. The reason why has less to do with how computers are made and how they age and more to do with the way we use them. You see, all of the daily tasks that we do on our PC from running programs to downloading and deleting software can make our computer sluggish. To keep this from happening, you need to understand the reasons why your PC is getting slower and do something to keep your PC running at its best. You can do this through regular maintenance and PC performance optimization programs")]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v("Before we discuss all of the things that could be affecting your PC’s performance, let’s talk a little about what symptoms")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/elements/d.jpg",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Definition")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 01")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 02")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "single-defination"
  }, [_c('h4', {
    staticClass: "mb-20"
  }, [_vm._v("Definition 03")]), _vm._v(" "), _c('p', [_vm._v("Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Block Quotes")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('blockquote', {
    staticClass: "generic-blockquote"
  }, [_vm._v("\n              “Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players found themselves being chased by the Federal government. But, after a fortnight, the online casino industry came up with a solution and new online casinos started taking root. These began to operate under a different business umbrella, and by doing that, rendered the transfer of money to and from them legal. A major part of this was enlisting electronic banking systems that would accept this new clarification and start doing business with me. Listed in this article are the electronic banking”\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Table")]), _vm._v(" "), _c('div', {
    staticClass: "progress-table-wrap"
  }, [_c('div', {
    staticClass: "progress-table"
  }, [_c('div', {
    staticClass: "table-head"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("#")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_vm._v("Countries")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("Visits")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_vm._v("Percentages")])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f1.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-1",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "80",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f2.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-2",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "30",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f3.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-3",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "55",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("04")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f4.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-4",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("05")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f5.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-5",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "40",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("06")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f6.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-6",
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "70",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("07")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f7.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-7",
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "30",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-row"
  }, [_c('div', {
    staticClass: "serial"
  }, [_vm._v("08")]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/elements/f8.jpg",
      "alt": "flag"
    }
  }), _vm._v("Canada")]), _vm._v(" "), _c('div', {
    staticClass: "visit"
  }, [_vm._v("645032")]), _vm._v(" "), _c('div', {
    staticClass: "percentage"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar color-8",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "60",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('h3', {
    staticClass: "title_color"
  }, [_vm._v("Image Gallery")]), _vm._v(" "), _c('div', {
    staticClass: "row gallery-item"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g1.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g1.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g2.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g2.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g3.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g3.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g4.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g4.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g5.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g5.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g6.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g6.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g7.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g7.jpg)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('a', {
    staticClass: "img-gal",
    attrs: {
      "href": "static/assets/images/elements/g8.jpg"
    }
  }, [_c('div', {
    staticClass: "single-gallery-image",
    staticStyle: {
      "background": "url(static/assets/images/elements/g8.jpg)"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-sm-6 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "typography"
  }, [_c('h1', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")]), _vm._v(" "), _c('h2', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 02")]), _vm._v(" "), _c('h3', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 03")]), _vm._v(" "), _c('h4', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 04")]), _vm._v(" "), _c('h5', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")]), _vm._v(" "), _c('h6', {
    staticClass: "typo-list"
  }, [_vm._v("This is header 01")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-6 mt-sm-30 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Unordered List")]), _vm._v(" "), _c('div', {}, [_c('ul', {
    staticClass: "unordered-list"
  }, [_c('li', [_vm._v("Fta Keys")]), _vm._v(" "), _c('li', [_vm._v("For Women Only Your Computer Usage")]), _vm._v(" "), _c('li', [_vm._v("Facts Why Inkjet Printing Is Very Appealing\n                  "), _c('ul', [_c('li', [_vm._v("Addiction When Gambling Becomes\n                      "), _c('ul', [_c('li', [_vm._v("Protective Preventative Maintenance")])])])])]), _vm._v(" "), _c('li', [_vm._v("Dealing With Technical Support 10 Useful Tips")]), _vm._v(" "), _c('li', [_vm._v("Make Myspace Your Best Designed Space")]), _vm._v(" "), _c('li', [_vm._v("Cleaning And Organizing Your Computer")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-6 mt-sm-30 typo-sec"
  }, [_c('h3', {
    staticClass: "mb-20 title_color"
  }, [_vm._v("Ordered List")]), _vm._v(" "), _c('div', {}, [_c('ol', {
    staticClass: "ordered-list"
  }, [_c('li', [_c('span', [_vm._v("Fta Keys")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("For Women Only Your Computer Usage")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Facts Why Inkjet Printing Is Very Appealing")]), _vm._v(" "), _c('ol', {
    staticClass: "ordered-list-alpha"
  }, [_c('li', [_c('span', [_vm._v("Addiction When Gambling Becomes")]), _vm._v(" "), _c('ol', {
    staticClass: "ordered-list-roman"
  }, [_c('li', [_c('span', [_vm._v("Protective Preventative Maintenance")])])])])])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Dealing With Technical Support 10 Useful Tips")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Make Myspace Your Best Designed Space")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Cleaning And Organizing Your Computer")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section-top-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Form Element")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "First Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'First Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": "Last Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Last Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "last_name",
      "placeholder": "Last Name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Last Name'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "email",
      "name": "EMAIL",
      "placeholder": "Email address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Email address'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumb-tack",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "single-input",
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": "Address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Address'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plane",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-select",
    attrs: {
      "id": "default-select"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Dhaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Dilli")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Newyork")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Islamabad")])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-icon mt-10"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-select",
    attrs: {
      "id": "default-select2"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bangladesh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("India")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("England")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Srilanka")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('textarea', {
    staticClass: "single-textarea",
    attrs: {
      "placeholder": "Message",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Message'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-primary",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Primary color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Primary color'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-accent",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Accent color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Accent color'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-10"
  }, [_c('input', {
    staticClass: "single-input-secondary",
    attrs: {
      "type": "text",
      "name": "first_name",
      "placeholder": "Secondary color",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Secondary color'",
      "required": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-4 mt-sm-30 element-wrap"
  }, [_c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Switches")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample Switch")]), _vm._v(" "), _c('div', {
    staticClass: "primary-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-switch"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-switch"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color Switch")]), _vm._v(" "), _c('div', {
    staticClass: "primary-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-switch",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-switch"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color Switch")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-switch",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-switch"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Selectboxes")]), _vm._v(" "), _c('div', {
    staticClass: "default-select",
    attrs: {
      "id": "default-select"
    }
  }, [_c('select', [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Arabic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Portuguise")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Bengali")])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Checkboxes")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "primary-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "primary-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("04. Disabled Checkbox")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-checkbox",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("05. Disabled Checkbox active")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-checkbox-active",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-checkbox-active"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-element-widget"
  }, [_c('h3', {
    staticClass: "mb-30 title_color"
  }, [_vm._v("Radios")]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("01. Sample radio")]), _vm._v(" "), _c('div', {
    staticClass: "primary-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "default-radio"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "default-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("02. Primary Color radio")]), _vm._v(" "), _c('div', {
    staticClass: "primary-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "primary-radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "primary-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("03. Confirm Color radio")]), _vm._v(" "), _c('div', {
    staticClass: "confirm-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "confirm-radio",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("04. Disabled radio")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-radio",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-radio"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "switch-wrap d-flex justify-content-between"
  }, [_c('p', [_vm._v("05. Disabled radio active")]), _vm._v(" "), _c('div', {
    staticClass: "disabled-radio"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "disabled-radio-active",
      "checked": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disabled-radio-active"
    }
  })])])])])])])])])])
}]}

/***/ })
],[180]);


// WEBPACK FOOTER //
// static/js/app.49f2b313423968da2fd0.js